import { loadScript } from "../../utils";
const ALMA_NATIVE_VIDEO_PLAYER_ID = "W7umgEo0";
let almaNativeVideoPlayerReady = false;
let almaNativeVideoPlayerLoading = false;
const videoRequests = [];
function setupNativeVideoPlayer(playerConfiguration) {
    const playerInstanceConf = {
        file: "https://d14evu1q67bpdr.cloudfront.net/video/jw/blank_1s.mp4",
        image: playerConfiguration.posterImage,
        displayPlaybackLabel: true,
        autostart: true,
        mute: true,
        autoPause: {
            viewability: true,
            pauseAds: true,
        },
        advertising: {
            admessage: "",
            cuetext: "Advertisement",
            client: "vast",
            schedule: [
                {
                    offset: "pre",
                    vastxml: playerConfiguration.vastXML,
                    type: "linear",
                },
            ],
        },
        intl: {
            fi: {
                playback: "Katso video",
            },
        },
    };
    const playerInstance = window.jwplayer(playerConfiguration.videoElementId);
    playerInstance.setup(playerInstanceConf);
}
async function initAlmaNativeVideo(videoElementId, vastXML, posterImage) {
    if (!almaNativeVideoPlayerReady) {
        videoRequests.push({ videoElementId, vastXML, posterImage });
        if (almaNativeVideoPlayerLoading) {
            return;
        }
        almaNativeVideoPlayerLoading = true;
        await loadScript(`https://content.jwplatform.com/libraries/${ALMA_NATIVE_VIDEO_PLAYER_ID}.js`, window);
        almaNativeVideoPlayerReady = true;
        almaNativeVideoPlayerLoading = false;
        while (videoRequests.length > 0) {
            const request = videoRequests.shift();
            if (request) {
                setupNativeVideoPlayer(request);
            }
        }
    }
    else {
        setupNativeVideoPlayer({ videoElementId, vastXML, posterImage });
    }
}
export default initAlmaNativeVideo;
//# sourceMappingURL=native-video.js.map